/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { IDialogMessage } from 'src/app/@amiga-pyme/components/ami-dialog-message/ami-dialog-message.interface';
import { CrudService } from 'src/app/@amiga-pyme/services/crud.service';

@Component({
  template: ''
})
export class UpdateTemplate {
  open = true;
  @Output() close = new EventEmitter<boolean>();
  @Input() row: any;
  message: IDialogMessage;
  fg: FormGroup;

  constructor(
    @Inject(String) private name: string,
    private service: CrudService
  ) {}

  async updateItem$(data: any) {
    this.message = { message: `Actualizando ${this.name}` };
    this.message = await this.service.update(this.row?.id, data);
    const status = this.message.status;
    if (status === 200) {
      this.service.getData$();
      setTimeout(() => {
        this.onClose();
      }, 1500);
    }
  }

  async updateItemWithoutId$(data: any) {
    this.message = { message: `Actualizando ${this.name}` };
    this.message = await this.service.updateWithoutId(this.row?.id, data);
    const status = this.message.status;
    if (status === 200) {
      setTimeout(() => {
        this.onClose();
      }, 1500);
    }
  }

  onClose() {
    this.close.emit();
  }
}
